var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareReddit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.532,
    y1: 1.084,
    x2: 0.5,
    y2: 0.331,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f42212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff630a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.638,
    height: 31.638,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-181 -797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 88)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(181 709)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185 801.181)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.227,165.283a2.783,2.783,0,0,0-2.652-2.9,2.529,2.529,0,0,0-1.828.8,12.346,12.346,0,0,0-7.577-2.623l1.384-6.323,4.093,1.069c0,.006,0,.011,0,.016a1.972,1.972,0,1,0,1.964-2.146,1.954,1.954,0,0,0-1.755,1.186l-4.951-1.307,0,.02h0l-1.637,7.5a12.221,12.221,0,0,0-7.339,2.7,2.541,2.541,0,0,0-1.909-.889,2.782,2.782,0,0,0-2.652,2.9,2.884,2.884,0,0,0,1.814,2.747,6.433,6.433,0,0,0-.054.828c0,4.584,4.821,8.3,10.768,8.3s10.768-3.715,10.768-8.3a6.462,6.462,0,0,0-.064-.9,2.909,2.909,0,0,0,1.636-2.675m-18.564,2.279a1.877,1.877,0,1,1,1.869,2.041,1.961,1.961,0,0,1-1.869-2.041m11.294,5.579a7.9,7.9,0,0,1-10.14,0,.682.682,0,0,1-.087-.9.554.554,0,0,1,.826-.1,6.593,6.593,0,0,0,4.331,1.557,6.506,6.506,0,0,0,4.332-1.557.554.554,0,0,1,.825.1.682.682,0,0,1-.087.9m-.991-3.537a2.049,2.049,0,1,1,1.87-2.041,1.961,1.961,0,0,1-1.87,2.041",
    transform: "translate(-130.024 -149.314)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareReddit);
export default __webpack_public_path__ + "static/media/shareReddit.b99f40d6aaa50115152c3af33781164a.svg";
export { ForwardRef as ReactComponent };